import styled from 'styled-components';

export const Container = styled.aside`
  position: relative;
  border: ${props => `${props.theme.borderWidths.small} dotted ${props.theme.colors.capsuleRed}`};
  margin: ${props => props.theme.space.s2};
  padding: ${props => props.theme.space.s3};
`;

export const Title = styled.header`
  position: absolute;
  left: ${props => props.theme.space.s3};
  top: -${props => props.theme.space.s4};
  background-color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.space.s1};
`;
